<template lang="pug">

</template>
<script>
export default {
  created(){
    this.$router.push({
      name:"statement",
      params:{
        "checkTrans": true
      }
    }).catch(error =>{})
  }
}
</script>